import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { ShowcaseTileToggleContainer, ShowcaseTileToggleItem, ShowcaseTileToggleWrapper, } from '../styles';
const ShowcaseTileToggle = ({ duration, setDuration, }) => {
    const { t } = useTranslations();
    const handleMonthly = () => {
        setDuration('monthly');
    };
    const handleYearly = () => {
        setDuration('yearly');
    };
    return (_jsx(ShowcaseTileToggleWrapper, { children: _jsxs(ShowcaseTileToggleContainer, { children: [_jsx(ShowcaseTileToggleItem, { onClick: handleMonthly, "$active": duration === 'monthly', children: _jsx(Typography, { elementTheme: "overline", nowrap: true, children: t('plansDurations|monthlyToggle') }) }), _jsx(ShowcaseTileToggleItem, { onClick: handleYearly, "$active": duration === 'yearly', children: _jsx(Typography, { elementTheme: "overline", nowrap: true, children: t('plansDurations|yearlyToggle') }) })] }) }));
};
export default ShowcaseTileToggle;
